export enum ROLES {
  admin = 'admin',
  monitor = 'monitor',
  student = 'student',
  advisor = 'advisor',
  support = 'support',
}
